import axios from "axios";
import { useEffect, useState } from "react";

const AllFeatures = () => {
    const [allFeatures, setAllFeatures] = useState(null);

    const fetchAllFeatures = async() => {
        try{
            const res = await axios.get(
                `${import.meta.env.VITE_BACKEND_API_URL}/admin/get-all-features`,
                { withCredentials: true }
            );

            if(res.data.success){
                setAllFeatures(res.data.features);
            }
        }
        catch(err){
            console.error("Error fetching features", err);
        }
    };

    useEffect(() => {
        fetchAllFeatures();
    }, []);


     const isMatchingPage = 
     typeof window !== "undefined" &&
     [
        "streaming-server",
        "streaming-server-new-york",
        "streaming-server-montreal",
        "streaming-server-london",
        "streaming-server-los-angeles"
    ].some(path => window.location.pathname.includes(path));

    const filteredFeatures = isMatchingPage
        ? allFeatures?.filter((feature) => 
            ["serverFeature", "keyFeature", "cPFeature", "securityFeature"].includes(feature.key)
        )
        : allFeatures;

    return (
        <div>
            {filteredFeatures  && (
                <> 
                    <div className="container all-feature-container">
                        <div className="row">
                            <div className="col-12">
                                <div className="feature-tabbing pricing-nav-pills d-block mx-auto border-bottom border-light border-opacity-25 sal-animate" data-sal="fade" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                    <ul className={`nav nav-pills justify-content-sm-center ${isMatchingPage ? "all-centered" : ""}`} role="tablist">
                                        { filteredFeatures.map((tab, index) => (
                                            <li className="nav-item" role="presentation" key={tab.key}>
                                                <a
                                                    className={`partner-tab-nev d-inline-block text-decoration-none text-white fw-bold px-3 pb-2 ${index === 0 ? "active" : ""}`}
                                                    href="#"
                                                    data-bs-toggle="pill"
                                                    data-bs-target={`#${tab.key}`}
                                                    aria-selected={index === 0 ? "true" : "false"}
                                                    role="tab"
                                                >
                                                    {tab.title}
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="tab-content feature-tabbing-main mt-4">
                                    {filteredFeatures.map((tab, index) => (
                                        <div
                                            key={tab.key}
                                            className={`tab-pane fade ${index === 0 ? "show active" : ""}`}
                                            id={tab.key}
                                            role="tabpanel"
                                        >
                                            <div className="row">
                                                {tab.data.map((item) => (
                                                    <div className="col-lg-4 col-md-6 mb-2" key={item._id}>
                                                        <div className="feature-wrapper h-100">
                                                            <p><span className="tab-check-icon"><i className="fa-solid fa-check-double"></i></span>{item.name}</p>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default AllFeatures;
